module.exports = __webpack_public_path__ + "media/images/wines/blanco-airen/bottle-detail-4ea6a2c70f787de05d252334547bd0fc.png";